import React, { JSX } from 'react';
import { Provider } from 'components/types/LocationTypes';
import Texts from '../../../assets/utils/texts';
import LocationProvider from './LocationProvider';

type LocationProvidersProps = {
  providers: Array<Provider>;
};

const LocationProviders = ({
  providers,
}: LocationProvidersProps): JSX.Element => {
  const sortedProviders = [...providers].sort((a, b) =>
    (a?.FullName?.value || '').localeCompare(
      b?.FullName?.value || ''
    )
  );

  return (
    <div className="profile-section location-providers">
      <div className="content">
        <h2>{Texts.Providers}</h2>

        <ul className="link-list">
          {sortedProviders.map((provider, index) => (
            <LocationProvider
              provider={provider}
              key={
                provider?.ExternalID?.value ||
                `provider-${index}`
              }
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LocationProviders;